import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import AppleIcon from "@mui/icons-material/Apple";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import {PaymentMethod, PaymentMethodDisplayPolicy} from "../../../apis/requests/payment-flows/types";
import type {SvgIconComponent} from "@mui/icons-material";

export const PAYMENT_METHODS = ["ach", "card", "apple_pay"] as const satisfies readonly PaymentMethod[];

export const PAYMENT_METHOD_OPTIONS: Record<PaymentMethod, {label: string; Icon: SvgIconComponent}> = {
  card: {label: "Card", Icon: CreditCardOutlinedIcon},
  ach: {label: "ACH", Icon: AccountBalanceOutlinedIcon},
  apple_pay: {label: "Apple Pay", Icon: AppleIcon},
};

export const CURRENT_CHECKOUT_POLICY: PaymentMethodDisplayPolicy = {methods: [...PAYMENT_METHODS], default: "ach"};

export const DISPLAY_CONDITION_PARAMETERS = new Set(["partner_code"]);
